import React from "react";
import "./styles.scss";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { strings } from "../../../I18n";

function FilterDialog(props) {
  const { visible, hideDialog, body, cancel, apply } = props;
  return (
    <Dialog fullWidth={true} onClose={hideDialog} open={visible}>
      <DialogTitle>{strings("message.filterSettings")}</DialogTitle>
      {body}
      <DialogActions>
        <Button onClick={cancel} color="primary">
          {strings("buttons.cancel")}
        </Button>
        <Button onClick={apply} color="primary" autoFocus={true}>
          {strings("buttons.apply")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FilterDialog;
